import styled from "styled-components";
import {
  FormControl,
  Paper,
  InputLabel,
  Radio,
} from "@mui/material";

const SelectContainer = styled.div`
  width: 800px;
  height: fit-content;
  padding: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.primaryWhite};
  display: flex;
  flex-direction: column;

  p {
    color: ${(props) =>
      props.disabled
        ? props.theme.colors.clearGray
        : props.theme.colors.darkGray};
  }
`;

const HeaderSelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  padding: 0 8px;

  p {
    color: ${(props) =>
      props.disabled
        ? props.theme.colors.clearGray
        : props.theme.colors.darkGray};
  }
`;

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledRadio = styled(Radio)`
  && {
    padding: 0;
    color: ${(props) => props.theme.colors.clearGray};

    &.Mui-checked {
      color: ${(props) =>
        props.disabled
          ? props.theme.colors.clearGray
          : props.theme.colors.clearBlue};
    }
  }
`;

const ChipName = styled.span`
  font-weight: bold;
`;

const ChipRole = styled.span`
  font-family: ${(props) => props.theme.fonts.family.inter};
`;

const TagsContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  border-radius: 8px;
  padding: 16px;
  min-height: 70px;
  width: 784px;
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const StyledFormControl = styled(FormControl)`
  && {
    max-width: 784px;
    background: ${(props) => props.theme.colors.primaryWhite};
    border-radius: 8px;
  }

  && .MuiOutlinedInput-root {
    border-radius: 8px;
  }
`;

const StyledInputLabel = styled(InputLabel)`
  && {
    padding: 0;
  }
`;

const StyledPaper = styled(Paper)`
  && {
    background-color: ${(props) => props.theme.colors.highClearGray};
    padding: 1rem;
    width: 250px;
    max-height: 160px;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 8px;

    & > ul {
      border-radius: 8px;
      background-color: ${(props) => props.theme.colors.white};
      border: 1px solid ${(props) => props.theme.colors.clearGray};

      & > li {
        border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
        font-family: ${(props) => props.theme.fonts.family.inter};
        padding: 10px 16px;

        &:last-child {
          border-bottom: none;
        }

        &[aria-disabled="true"] {
          font-style: italic;
          color: ${(props) => props.theme.colors.gray};
        }
      }
    }
  }
`;

export {
  HeaderSelectContainer,
  SelectContainer,
  RadioContainer,
  StyledRadio,
  ChipName,
  ChipRole,
  TagsContainer,
  StyledFormControl,
  StyledInputLabel,
  StyledPaper,
};
